import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import user from './modules/user'
import rules from './modules/rules'
import alert from './modules/alert'
import search from './modules/search'
import socket from './modules/socket'
import social from './modules/social'
import hngrow from './modules/hngrow'
import academy from './modules/academy-success'
import webinars from './modules/webinars'
import mainPage from './modules/mainPage'
import trainings from './modules/trainings'
import favorites from './modules/favorites'
import statistic from './modules/statistic'
import intensive from './modules/intensive'
import serverTime from './modules/serverTime'
import screencasts from './modules/screencasts'
import leaderboard from './modules/leaderboard'
import distribution from './modules/distribution'
import gamefication from './modules/gamefication'
import coinsExchange from './modules/coinsExchange'
import successLadder from './modules/successLadder'
import staticContent from './modules/static'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    rules,
    alert,
    search,
    socket,
    social,
    hngrow,
    academy,
    webinars,
    mainPage,
    trainings,
    favorites,
    statistic,
    intensive,
    serverTime,
    screencasts,
    distribution,
    leaderboard,
    gamefication,
    coinsExchange,
    successLadder,
    staticContent,
  },
})
